/*
 * Copyright (C) 2025 SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { isArrayNotEmpty  } from "cms/utils/empty-exists";
import { LinkButtonItem } from "./link-button-item";

const LinkButtonComponent = (props) => {

    const component = props?.component;
    const buttonList = component?.button_list;

    return (
        <div className={"link-button-component"}>
            {isArrayNotEmpty(buttonList) &&
                buttonList.map((item, index) => (
                    <LinkButtonItem
                        key={index}
                        item={item}
                    />
                ))
            }
        </div>
    );
};

LinkButtonComponent.displayName = "LinkButtonComponent";
export { LinkButtonComponent };
